import { useEffect } from "react";
import SEO_ROUTES from "../../seo-routes.json";

export const SITE_URL = "https://pgpsusa.com";
const LOGO = `${SITE_URL}/assets/pgps-logo.jpg`;

function upsert(selector, create, attrs) {
  let el = document.head.querySelector(selector);
  const dupes = document.head.querySelectorAll(selector);
  dupes.forEach((d, i) => { if (i > 0) d.remove(); });
  if (!el) { el = create(); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}
const meta = (key, name, content) => upsert(`meta[${key}="${name}"]`, () => document.createElement("meta"), { [key]: name, content });

export function Seo({ route, title, description, path = "/", noindex = false, jsonLd = null }) {
  const m = route ? SEO_ROUTES[route] : null;
  if (m) { title = m.title; description = m.description; path = route; }
  const fullTitle = title.includes("Patrick Global") ? title : `${title} | Patrick Global`;
  const url = `${SITE_URL}${path}`;
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    document.title = fullTitle;
    document.head.querySelectorAll("title").forEach((t, i) => { if (i > 0) t.remove(); });
    meta("name", "description", description);
    meta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    upsert('link[rel="canonical"]', () => document.createElement("link"), { rel: "canonical", href: url });
    meta("property", "og:type", "website");
    meta("property", "og:site_name", "Patrick Global Procurement Services");
    meta("property", "og:title", fullTitle);
    meta("property", "og:description", description);
    meta("property", "og:url", url);
    meta("property", "og:image", LOGO);
    meta("property", "og:locale", "en_US");
    meta("name", "twitter:card", "summary");
    meta("name", "twitter:title", fullTitle);
    meta("name", "twitter:description", description);
    meta("name", "twitter:image", LOGO);
    let script = document.getElementById("seo-jsonld");
    if (ld) {
      if (!script) { script = document.createElement("script"); script.id = "seo-jsonld"; script.type = "application/ld+json"; document.head.appendChild(script); }
      script.textContent = ld;
    } else if (script) {
      script.remove();
    }
  }, [fullTitle, description, url, noindex, ld]);

  return null;
}

export function serviceSchema({ name, description, path, serviceType }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    serviceType: serviceType || name,
    description,
    url: `${SITE_URL}${path}`,
    provider: { "@id": `${SITE_URL}/#organization` },
    areaServed: [
      { "@type": "City", name: "Houston" },
      { "@type": "City", name: "Sugar Land" },
      { "@type": "City", name: "Katy" },
      { "@type": "AdministrativeArea", name: "Fort Bend County" },
      { "@type": "AdministrativeArea", name: "Harris County" },
      { "@type": "State", name: "Texas" },
      { "@type": "Country", name: "United States" },
    ],
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem", position: i + 1, name: it.name, item: `${SITE_URL}${it.path}`,
    })),
  };
}
